/* TANLO native PDP — Širdelė test.
   Contracts this file must not break (verified 2026-09-30):
   - The add-to-cart <button> must stay server-rendered inside .tpdp-atcwrap and its visible text must
     contain KREP (in stock) or PARDUOTA (sold out) in capitals. The pre-order app finds it by innerText
     and inserts #tpre-callout before it. Never re-render .tpdp-atcwrap's children.
   - The pre-order app only learns about a variant change from a `gp:item-selected` CustomEvent fired on a
     <gp-product-variants> element, with detail.data.selectedOptions = {Gintaras: v, Grandinėlė: v}.
   - Kaching Cart opens its drawer off a window.fetch patch, so always read window.fetch at click time and
     always call preventDefault() in the submit handler (otherwise Kaching adds a second line).
   - No quantity input: /cart/add.js returns 422 / partial adds. Quantity is a fixed hidden 1. */
(function () {
  'use strict';

  // The PDP is built from several sibling sections, so state is page-scoped, not element-scoped.
  var guard = document.querySelector('[data-tpdp-main]');
  if (!guard || guard.hasAttribute('data-tpdp-ready')) return;
  guard.setAttribute('data-tpdp-ready', '');
  var root = document;

  var cfgEl = root.querySelector('[data-tpdp-config]');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var form = root.querySelector('form.tpdp-pform');
  var idInput = form && form.querySelector('input[name="id"]');
  var shim = root.querySelector('[data-tpdp-shim]');
  var atc = root.querySelector('[data-tpdp-atc]');
  var atcLabel = root.querySelector('[data-tpdp-atc-label]');
  var errBox = root.querySelector('[data-tpdp-error]');
  var priceNow = root.querySelector('[data-tpdp-price-now]');
  var priceWas = root.querySelector('[data-tpdp-price-was]');
  var priceSave = root.querySelector('[data-tpdp-price-save]');
  var hintEl = root.querySelector('[data-tpdp-hint]');
  var optValueEls = root.querySelectorAll('[data-tpdp-opt-value]');
  // Only the facts the theme editor scoped to an option value. Unscoped facts carry no attribute,
  // are never in this list, and so are never touched.
  var factEls = root.querySelectorAll('[data-tpdp-fact-scope]');

  var state = { o1: CFG.initial.o1, o2: CFG.initial.o2 };

  function variantFor(o1, o2) {
    for (var i = 0; i < CFG.variants.length; i++) {
      var v = CFG.variants[i];
      if (v.o1 === o1 && v.o2 === o2) return v;
    }
    return null;
  }
  // key is 'o1' or 'o2' — which option a button belongs to is a per-product setting, because the
  // pendant is Gintaras/Grandinėlė and the bracelet is Dydis/Spalva.
  function anyAvailable(key, val) {
    for (var i = 0; i < CFG.variants.length; i++) {
      if (CFG.variants[i][key] === val && CFG.variants[i].available) return true;
    }
    return false;
  }
  function keyOf(btn) { return btn.getAttribute('data-opt') === '2' ? 'o2' : 'o1'; }
  function otherKey(k) { return k === 'o1' ? 'o2' : 'o1'; }
  // The colour cards further down the page carry only a value, so work out which option it belongs to.
  function keyForValue(val) {
    for (var i = 0; i < CFG.variants.length; i++) {
      if (CFG.variants[i].o1 === val) return 'o1';
      if (CFG.variants[i].o2 === val) return 'o2';
    }
    return null;
  }
  // A fact scope names option VALUES, comma separated, never an option position — the finish is
  // option 2 on the pendant and option 1 on the bracelet, so both selected values are tested.
  function norm(s) { return s == null ? '' : String(s).trim().toLowerCase(); }
  function inScope(scope) {
    var want = String(scope || '').split(',');
    for (var i = 0; i < want.length; i++) {
      var w = norm(want[i]);
      // An empty entry (trailing comma) must not match a single-option product's null option2.
      if (!w) continue;
      if (w === norm(state.o1) || w === norm(state.o2)) return true;
    }
    return false;
  }
  var CHECK_SVG = '<svg class="tpdp-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ---------------- gallery ---------------- */
  var gal = (function () {
    var stage = root.querySelector('[data-tpdp-track]');
    if (!stage) return { toMedia: function () {} };
    var slides = [].slice.call(stage.querySelectorAll('[data-tpdp-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-tpdp-thumb]'));
    var counter = root.querySelector('[data-tpdp-counter]');
    var current = 0;

    function mark(i) {
      if (i < 0 || i >= slides.length) return;
      current = i;
      if (counter) counter.textContent = (i + 1) + '/' + slides.length;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      /* Carry the thumbnail strip along. It is a single nowrap row on desktop, so without this the
         active thumb walks off the end and the strip looks stuck. Nudged by the minimum amount
         rather than centred, so the row only moves when it has to. */
      var th = thumbs[i];
      if (th && th.offsetParent) {
        var strip = th.parentNode;
        var left = th.offsetLeft - strip.offsetLeft;
        var right = left + th.offsetWidth;
        if (left < strip.scrollLeft) strip.scrollLeft = left - 10;
        else if (right > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = right - strip.clientWidth + 10;
      }
    }
    function go(i, smooth) {
      /* Wrap rather than clamp: stopping dead at the last photo reads as a broken arrow,
         and the thumbnail strip already tells the shopper where they are. */
      if (slides.length === 0) return;
      if (i < 0) i = slides.length - 1;
      if (i > slides.length - 1) i = 0;
      /* 'smooth' is a silent no-op on these scroll-snap tracks — scrollLeft never moves,
         which killed colour->image sync, the arrows and the thumbnails. Always jump, and
         assign scrollLeft as well so the landing position is guaranteed. Swipe stays
         native-smooth, so nothing user-visible is lost. */
      var want = slides[i].offsetLeft - stage.offsetLeft;
      stage.scrollTo({ left: want, behavior: 'auto' });
      if (stage.scrollLeft !== want) stage.scrollLeft = want;
      mark(i);
    }
    var tick;
    stage.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
        slides.forEach(function (s, n) {
          var c = s.offsetLeft - stage.offsetLeft + s.clientWidth / 2, d = Math.abs(c - mid);
          if (d < bd) { bd = d; best = n; }
        });
        mark(best);
      }, 90);
    }, { passive: true });

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n, true); }); });
    var prev = root.querySelector('[data-tpdp-prev]');
    var next = root.querySelector('[data-tpdp-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    mark(0);

    /* Variant-only gallery (snippets/tanlo-pdp-gallery, variant_only): of the variant photos only the
       selected one is printed, in one slot. A colour change whose photo is not on the page swaps that
       slot's image from the data-tpdp-vmedia map and goes to it, so the slide count never changes. */
    var vmedia = null;
    var vmEl = root.querySelector('[data-tpdp-vmedia]');
    if (vmEl) { try { vmedia = JSON.parse(vmEl.textContent); } catch (e) { vmedia = null; } }
    var vslot = stage.querySelector('[data-tpdp-vslot]');
    var vthumb = root.querySelector('[data-tpdp-vslot-thumb]');

    return {
      toMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i, true); return; }
        }
        var m = vmedia && vmedia[String(mediaId)];
        if (!vslot || !m) return;
        var img = vslot.querySelector('img');
        if (img) {
          img.setAttribute('srcset', m.srcset);
          img.src = m.src;
          img.alt = m.alt || '';
          if (m.w) img.setAttribute('width', m.w);
          if (m.h) img.setAttribute('height', m.h);
        }
        vslot.setAttribute('data-media-id', String(mediaId));
        if (vthumb) {
          var ti = vthumb.querySelector('img');
          if (ti && m.thumb) ti.src = m.thumb;
        }
        go(slides.indexOf(vslot), true);
      }
    };
  })();

  /* ---------------- pre-order app handshake ----------------
     The app renders its own initial state from ?variant= or its first variant. We only start telling it
     about changes once it has actually mounted, so we never pre-empt its geo lookup. */
  var appReady = false;
  function appMounted() { return !!document.getElementById('tpre-callout') || !!document.getElementById('tpre-stock-info'); }
  function tellApp() {
    if (!appReady || !shim) return;
    var detail = { data: { selectedOptions: {} } };
    detail.data.selectedOptions[CFG.optionNames[0]] = state.o1;
    if (CFG.optionNames[1]) detail.data.selectedOptions[CFG.optionNames[1]] = state.o2;
    try { shim.dispatchEvent(new CustomEvent('gp:item-selected', { bubbles: true, detail: detail })); } catch (e) {}
  }
  (function watchApp() {
    if (appMounted()) { appReady = true; tellApp(); return; }
    var stop = false;
    var mo = new MutationObserver(function () {
      if (stop || !appMounted()) return;
      stop = true; mo.disconnect(); appReady = true; tellApp();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { if (!stop) { stop = true; mo.disconnect(); } }, 15000);
  })();

  /* ---------------- render ---------------- */
  function render(userDrove) {
    var v = variantFor(state.o1, state.o2);

    // swatches — struck through when no combination with that value is available at all
    root.querySelectorAll('[data-tpdp-sw]').forEach(function (b) {
      var k = keyOf(b), val = b.getAttribute('data-value');
      b.setAttribute('aria-pressed', val === state[k] ? 'true' : 'false');
      b.setAttribute('data-soldout', anyAvailable(k, val) ? '0' : '1');
    });
    // chips — disabled when that combination does not exist or is unavailable
    root.querySelectorAll('[data-tpdp-chip]').forEach(function (b) {
      var k = keyOf(b), o = otherKey(k), val = b.getAttribute('data-value');
      var probe = {};
      probe[k] = val;
      probe[o] = state[o];
      var cv = variantFor(probe.o1, probe.o2);
      b.setAttribute('aria-pressed', val === state[k] ? 'true' : 'false');
      if (cv && cv.available) b.removeAttribute('disabled'); else b.setAttribute('disabled', '');
      /* Two different things, two different signals — the swatches already make this
         distinction and the chips did not. [disabled] alone means "not with the colour you
         picked", which is temporary; data-soldout means the size is gone in every colour.
         Without it a size that no longer exists looked identical to one you can reach by
         changing colour first. */
      b.setAttribute('data-soldout', anyAvailable(k, val) ? '0' : '1');
    });
    optValueEls.forEach(function (el) {
      el.textContent = el.getAttribute('data-tpdp-opt-value') === '1' ? state.o1 : state.o2;
    });
    // Scoped fact bullets: "Netamsėja ir atsparus vandeniui" is only true of the uncoated finish, so
    // the claim follows the selection. Driven off state, not off the resolved variant, so it stays
    // right even on a combination that does not exist — and it matches what Liquid rendered.
    factEls.forEach(function (li) {
      li.hidden = !inScope(li.getAttribute('data-tpdp-fact-scope'));
    });
    // colour cards downpage: mirror the selection and swap their status line
    root.querySelectorAll('[data-tpdp-shade]').forEach(function (b) {
      var val = b.getAttribute('data-value');
      var k = keyForValue(val);
      var on = !!k && state[k] === val;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var st = b.querySelector('[data-tpdp-shade-st]');
      if (!st) return;
      if (k && !anyAvailable(k, val)) { st.textContent = st.getAttribute('data-soldout') || ''; }
      else if (on) { st.innerHTML = CHECK_SVG + (st.getAttribute('data-picked') || ''); }
      else { st.textContent = st.getAttribute('data-pick') || ''; }
    });

    if (v) {
      if (idInput && idInput.value !== String(v.id)) {
        idInput.value = String(v.id);
        // tanlo-stock-cue listens for this
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) {
        if (v.compare) { priceWas.textContent = v.compare; priceWas.hidden = false; }
        else priceWas.hidden = true;
      }
      if (priceSave) {
        if (v.save) { priceSave.textContent = v.save; priceSave.hidden = false; }
        else priceSave.hidden = true;
      }
      if (atc) {
        if (v.available) {
          atc.removeAttribute('disabled');
          if (atcLabel) atcLabel.textContent = CFG.t.add;
        } else {
          atc.setAttribute('disabled', '');
          if (atcLabel) atcLabel.textContent = CFG.t.soldout;
        }
      }
      if (userDrove) {
        gal.toMedia(v.mediaId);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', String(v.id));
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
      if (hintEl) {
        var hv = hintEl.getAttribute('data-hint-value');
        hintEl.hidden = !(hv && (state.o1 === hv || state.o2 === hv));
      }
      syncSticky(v);
      // The pre-order app swaps in its own button asynchronously, so re-read its label shortly after.
      setTimeout(function () { syncSticky(variantFor(state.o1, state.o2)); }, 600);
    } else if (atc) {
      atc.setAttribute('disabled', '');
      if (atcLabel) atcLabel.textContent = CFG.t.soldout;
    }
    if (errBox) errBox.hidden = true;
    if (userDrove) tellApp();
    /* Let other sections follow the buy box without reaching into its internals. The cross-sell
       block uses this to inherit the chosen finish. Fires on first render too, so a section that
       loads after us still gets the opening state. */
    try {
      document.dispatchEvent(new CustomEvent('tpdp:variant', {
        detail: {
          o1: state.o1,
          o2: state.o2,
          optionNames: CFG.optionNames || [],
          variantId: variantFor(state.o1, state.o2) ? variantFor(state.o1, state.o2).id : null,
          userDrove: !!userDrove
        }
      }));
    } catch (e) {}
  }

  // Picking a value keeps the other option when that pair works, otherwise falls to the first
  // available partner for the value just chosen.
  function pick(k, val) {
    if (val === state[k]) return;
    state[k] = val;
    var o = otherKey(k);
    var keep = variantFor(state.o1, state.o2);
    if (!keep || !keep.available) {
      for (var i = 0; i < CFG.variants.length; i++) {
        if (CFG.variants[i][k] === val && CFG.variants[i].available) { state[o] = CFG.variants[i][o]; break; }
      }
    }
    render(true);
  }
  root.querySelectorAll('[data-tpdp-sw]').forEach(function (b) {
    b.addEventListener('click', function () { pick(keyOf(b), b.getAttribute('data-value')); });
  });
  root.querySelectorAll('[data-tpdp-chip]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('disabled')) return;
      pick(keyOf(b), b.getAttribute('data-value'));
    });
  });
  // The shade cards downpage select the same option as the swatches.
  root.querySelectorAll('[data-tpdp-shade]').forEach(function (b) {
    b.addEventListener('click', function () {
      var val = b.getAttribute('data-value');
      var sw = root.querySelector('[data-tpdp-sw][data-value="' + val.replace(/"/g, '\\"') + '"]');
      if (sw) sw.click();
      var box = root.querySelector('[data-tpdp-buy]');
      if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------------- sticky bar ---------------- */
  var sticky = root.querySelector('[data-tpdp-sticky]');
  var stickyBtn = root.querySelector('[data-tpdp-sticky-btn]');
  var stickyName = root.querySelector('[data-tpdp-sticky-name]');
  var stickyPrice = root.querySelector('[data-tpdp-sticky-price]');
  var stickyImg = root.querySelector('[data-tpdp-sticky-img]');

  function syncSticky(v) {
    if (!sticky || !v) return;
    // Single-option products have o2 === null; joining blindly printed Paauksuotas / null.
    if (stickyName) stickyName.textContent = [state.o1, state.o2].filter(function (x) { return x != null && x !== ''; }).join(' / ');
    if (stickyPrice) stickyPrice.textContent = v.price;
    if (stickyImg && v.thumb && stickyImg.getAttribute('src') !== v.thumb) stickyImg.setAttribute('src', v.thumb);
    if (stickyBtn) {
      // When the pre-order app has taken over, mirror its label ("UŽSISAKYKITE IŠ ANKSTO") rather
      // than promising a normal add to cart. Otherwise the bar would misdescribe a 4–6 week wait.
      var pre = document.getElementById('tpre-btn');
      // Its label carries the price too ("UŽSISAKYKITE IŠ ANKSTO — €49.00"); the bar shows the price
      // alongside already, so keep only the words.
      var preLabel = pre && pre.offsetParent !== null
        ? (pre.innerText || '').split('—')[0].replace(/\s+/g, ' ').trim()
        : '';
      if (preLabel) { stickyBtn.removeAttribute('disabled'); stickyBtn.textContent = preLabel; }
      else if (v.available) { stickyBtn.removeAttribute('disabled'); stickyBtn.textContent = CFG.t.addShort; }
      else { stickyBtn.setAttribute('disabled', ''); stickyBtn.textContent = CFG.t.soldout; }
    }
  }
  if (stickyBtn) {
    // Hand the tap to the pre-order app's own button when it exists, else to the main one.
    stickyBtn.addEventListener('click', function () {
      var target = document.getElementById('tpre-btn') || atc;
      if (target) target.click();
    });
  }
  // Scroll position, not IntersectionObserver: IO callbacks are not delivered in some embedded
  // webviews, which would leave the bar permanently hidden with no error to show for it.
  if (sticky && atc) {
    var anchor = root.querySelector('[data-tpdp-atcwrap]');
    if (anchor) {
      var updateSticky = function () {
        var r = anchor.getBoundingClientRect();
        // Only once the real button has scrolled off the TOP. Deliberately not while it is still
        // below the fold: on a phone the button starts off-screen, and showing the bar there would
        // put two add-to-cart buttons on the first screen.
        sticky.setAttribute('data-show', r.bottom < 40 ? '1' : '0');
      };
      // One getBoundingClientRect per scroll event, with no requestAnimationFrame gate: a dropped
      // rAF callback would latch the throttle flag and freeze the bar for the rest of the session.
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
    }
  }

  /* ---------------- add to cart ---------------- */
  function drawerOpened() {
    return !!document.querySelector('kaching-cart[open], .kaching-cart--open, [data-kaching-cart-open="true"]');
  }
  function nudgeDrawer() {
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') {
        window.kachingCartApi.openCart({ refetchCart: true });
        return;
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('kaching-cart:open', { detail: { cartOpenSource: 'add-to-cart' } }));
    } catch (e) {}
  }

  if (form) {
    form.addEventListener('submit', function (ev) {
      // Always preventDefault: Kaching's capture-phase submit listener would otherwise add a second line.
      ev.preventDefault();
      if (!atc || atc.hasAttribute('disabled') || atc.getAttribute('data-busy') === '1') return;
      atc.setAttribute('data-busy', '1');
      if (errBox) errBox.hidden = true;

      var body = new FormData(form);
      body.set('quantity', '1');
      var opened = false;
      function seen() { opened = true; }
      document.addEventListener('kaching-cart:open', seen, { once: true });

      // window.fetch is read here, not at load: Kaching patches it when its module boots.
      window.fetch(CFG.addUrl, {
        method: 'POST',
        body: body,
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) return res.json().catch(function () { return {}; }).then(function (j) { throw new Error((j && j.description) || CFG.t.err); });
        return res.json();
      }).then(function () {
        setTimeout(function () {
          if (!opened && !drawerOpened()) nudgeDrawer();
        }, 1000);
      }).catch(function (e) {
        if (errBox) { errBox.textContent = (e && e.message) || CFG.t.err; errBox.hidden = false; }
      }).then(function () {
        atc.removeAttribute('data-busy');
        document.removeEventListener('kaching-cart:open', seen);
      });
    });
  }

  /* ---------------- reviews: show more + photo lightbox ----------------
     Same behaviour as the live wall: six more per click, button removed once the list is exhausted. */
  var rvMore = root.querySelector('[data-tpdp-rv-more]');
  if (rvMore) {
    rvMore.addEventListener('click', function () {
      var rest = root.querySelectorAll('.tpdp-rv__card[data-tpdp-rv-hidden][hidden]');
      for (var i = 0; i < rest.length && i < 6; i++) rest[i].removeAttribute('hidden');
      if (rest.length <= 6) rvMore.parentNode.removeChild(rvMore);
    });
  }

  var lb = root.querySelector('[data-tpdp-rv-lb]');
  if (lb && typeof lb.showModal === 'function') {
    var lbImg = lb.querySelector('img');
    var lbTxt = lb.querySelector('.tpdp-rv__lbtext');
    root.querySelectorAll('[data-tpdp-rv-ph]').forEach(function (b) {
      b.addEventListener('click', function () {
        lbImg.src = b.getAttribute('data-full');
        lbImg.alt = b.querySelector('img').alt;
        lbTxt.querySelector('.tpdp-rv__stars').textContent = '★★★★★'.slice(0, +b.getAttribute('data-rating'));
        lbTxt.querySelector('strong').textContent = b.getAttribute('data-author');
        lbTxt.querySelector('p').textContent = b.getAttribute('data-text');
        lb.showModal();
      });
    });
    var lbClose = root.querySelector('[data-tpdp-rv-close]');
    if (lbClose) lbClose.addEventListener('click', function () { lb.close(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
  }

  render(false);

  /* render(false) deliberately skips the gallery so we don't fight a ?variant= deep link
     or the pre-order app on first paint — but that left the gallery parked on slide 1
     while a different colour was preselected. On Širdelė that showed an orange Klasikinis
     stone under a "Žalias" label. Sync once, deferred so slide offsets are measured. */
  setTimeout(function () {
    var v0 = variantFor(state.o1, state.o2);
    if (v0 && v0.mediaId) gal.toMedia(v0.mediaId);
  }, 0);
})();

/* ---------------- cross-sell carousel ----------------
   Its own IIFE, appended after the main one: that block returns early when the page has no
   [data-tpdp-main] / [data-tpdp-config], and the cross-sell section also renders on pages with no
   buy box, so it must not inherit those guards. Guarded per element instead of per page, so two
   cross-sell sections on one page each get their own instance and neither double-binds.

   HOW THE ENDLESS LOOP WORKS
   The strip gets m copies of the LAST m real cards prepended and m copies of the FIRST m appended,
   where m is one more card than fits in the viewport — so the clone zone is always at least a
   screenful and the wrap never shows a gap. The real cards then live at scrollLeft in
   [base, base + loopW), where base is real card 0's offset and loopW is one full turn.

   A swipe past the last real card simply keeps scrolling, into clones of cards 0..m-1, so it looks
   like the strip continues. Once the scroll SETTLES (no scroll event for 110ms) and no finger is
   down, normalize() shifts scrollLeft by exactly ±loopW with a direct assignment. The clone under
   the viewport is pixel-identical to the real card the shift lands on, including the sub-pixel
   offset (loopW is an integer difference of two offsetLefts, so the fractional part of scrollLeft
   survives), so nothing moves on screen. That is the whole trick: the teleport is invisible because
   it swaps identical pixels, not because it is animated.

   Why settle-time and not during the gesture: writing scrollLeft while a touch is in progress is
   either ignored or jerky on iOS, and momentum keeps firing scroll events after touchend — so the
   debounce naturally lands after the fling has died. If the settle timer does fire while a finger
   is still down it bails out, and the touchend/pointerup handlers re-arm it.

   Clones never duplicate a product for assistive tech or for a crawler: they are built at runtime
   (so the server HTML has one link per product), every clone is aria-hidden="true", and every
   focusable inside one gets tabindex="-1". Their href is left intact on purpose — a clone is a
   real card to the eye, and tapping one has to open the product rather than be a dead end.

   Degrades to the old no-wrap behaviour whenever a loop is not warranted: fewer than 3 cards, the
   section's "Endless swipe loop" setting off, or a strip that does not overflow its track (four
   cards at the desktop breakpoint fit exactly, so nothing is cloned there until the viewport
   narrows — the resize handler rebuilds on the way).

   No IntersectionObserver and no requestAnimationFrame anywhere in here, deliberately: neither
   fires in the preview webview. Autoplay, when it is switched on at all, is a setInterval that is
   cleared on hover, focus, touch and tab-hide — never a self-rescheduling frame callback, which
   would latch and never resume. */
(function () {
  'use strict';

  var cars = document.querySelectorAll('[data-tpdp-xs]');
  if (!cars.length) return;

  cars.forEach(function (root) {
    if (root.hasAttribute('data-tpdp-xs-ready')) return;
    root.setAttribute('data-tpdp-xs-ready', '');

    var track = root.querySelector('[data-tpdp-xs-track]');
    if (!track) return;

    // The real cards, captured before anything is cloned. This array never grows.
    var cards = [].slice.call(track.querySelectorAll('[data-tpdp-xs-card]'));
    var k = cards.length;
    if (k < 2) return;

    var dots = [].slice.call(root.querySelectorAll('[data-tpdp-xs-dot]'));
    var prev = root.querySelector('[data-tpdp-xs-prev]');
    var next = root.querySelector('[data-tpdp-xs-next]');

    // Section setting. Below 3 cards a loop is not worth cloning for, per the brief.
    var wantsLoop = root.getAttribute('data-loop') === '1' && k >= 3;

    var all = cards;      // every card in DOM order, clones included
    var head = 0;         // how many clones sit in front of the real cards
    var loopW = 0;        // pixel length of one full turn of the k real cards
    var looping = false;
    var current = 0;      // which REAL card is at the left edge, 0..k-1

    var TOL = 2;          // scrollLeft is fractional at non-integer zoom and on hidpi screens
    var SETTLE = 110;     // ms of scroll silence that counts as "stopped"

    /* ---------- geometry ---------- */
    function offsetOf(el) { return el.offsetLeft - track.offsetLeft; }
    function base() { return offsetOf(all[head]); }
    function pitch() { return offsetOf(cards[1]) - offsetOf(cards[0]); }
    function atStart() { return track.scrollLeft <= TOL; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - TOL; }

    /* ---------- clones ---------- */
    function cloneCard(src) {
      var c = src.cloneNode(true);
      // Not a real card any more: drop the marker so it never lands in the `cards` array, and
      // take it out of both the accessibility tree and the tab ring.
      c.removeAttribute('data-tpdp-xs-card');
      c.setAttribute('data-tpdp-xs-clone', '');
      c.setAttribute('aria-hidden', 'true');
      var f = c.querySelectorAll('a,button,input,select,textarea,[tabindex]');
      for (var i = 0; i < f.length; i++) f[i].setAttribute('tabindex', '-1');
      return c;
    }

    function dropClones() {
      var old = track.querySelectorAll('[data-tpdp-xs-clone]');
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
      track.classList.remove('tpdp-xs--loop');
      all = cards;
      head = 0;
      loopW = 0;
      looping = false;
    }

    function buildClones() {
      dropClones();
      if (!wantsLoop) return;
      // Nothing to wrap around if the whole strip is already on screen.
      if (track.scrollWidth <= track.clientWidth + TOL) return;

      var step = pitch();
      if (!(step > 0)) return;

      // One card more than fits, so the clone zone is never thinner than the viewport.
      var m = Math.min(k, Math.ceil(track.clientWidth / step) + 1);
      if (m < 1) return;

      var frag = document.createDocumentFragment();
      var i;
      for (i = 0; i < m; i++) frag.appendChild(cloneCard(cards[i]));
      track.appendChild(frag);                              // tail: copies of the first m

      frag = document.createDocumentFragment();
      for (i = k - m; i < k; i++) frag.appendChild(cloneCard(cards[i]));
      track.insertBefore(frag, cards[0]);                   // head: copies of the last m

      head = m;
      all = [].slice.call(track.children);
      track.classList.add('tpdp-xs--loop');

      // Measured, not multiplied: real card 0 to its tail clone IS one full turn, whatever the
      // card widths and gaps happen to be at this breakpoint.
      loopW = offsetOf(all[head + k]) - offsetOf(all[head]);
      if (!(loopW > 0)) { dropClones(); return; }

      looping = true;
      // Prepending shifted everything right. Park on real card 0 — instant, never smooth.
      track.scrollLeft = base();
    }

    /* ---------- dots ---------- */
    function mark(i) {
      current = i;
      for (var n = 0; n < dots.length; n++) {
        dots[n].setAttribute('aria-current', n === i ? 'true' : 'false');
      }
    }

    /* ---------- moves ---------- */
    function goDom(j, smooth) {
      if (j < 0) j = 0;
      if (j > all.length - 1) j = all.length - 1;
      var left = offsetOf(all[j]);
      try {
        /* See go() above: 'smooth' never lands on a scroll-snap track. */
        track.scrollTo({ left: left, behavior: 'auto' });
        if (track.scrollLeft !== left) track.scrollLeft = left;
      } catch (e) {
        // Older webviews reject the options object outright.
        track.scrollLeft = left;
      }
    }

    // i is a REAL card index. Wraps modularly while looping, clamps otherwise.
    function go(i, smooth) {
      if (looping) i = ((i % k) + k) % k;
      else if (i < 0) i = 0;
      else if (i > k - 1) i = k - 1;
      goDom(head + i, smooth);
      mark(i);
    }

    function step(dir) {
      if (looping) {
        // Scroll INTO the clone zone, so a step off either end animates forward like any other
        // step. normalize() puts us back on the real cards once this has settled. head >= 1, so
        // head + current + dir is always a valid index into `all`.
        goDom(head + current + dir, true);
        mark((((current + dir) % k) + k) % k);
        return;
      }
      // No loop: the old behaviour — a step past the end hops straight to the other end rather
      // than sliding back across the whole strip, which reads as a rewind.
      if (dir > 0) {
        if (atEnd()) go(0, false); else go(current + 1, true);
      } else {
        if (atStart()) go(k - 1, false); else go(current - 1, true);
      }
    }

    /* ---------- the teleport ----------
       Returns true when it moved. Only ever a bare scrollLeft assignment. */
    function normalize() {
      if (!looping || !loopW) return false;
      var b = base();
      var x = track.scrollLeft;
      if (x < b - TOL) { track.scrollLeft = x + loopW; return true; }
      if (x >= b + loopW - TOL) { track.scrollLeft = x - loopW; return true; }
      return false;
    }

    /* ---------- settle: where the teleport happens ---------- */
    var gesturing = false;
    var tick = null;

    function schedule() {
      clearTimeout(tick);
      tick = setTimeout(settle, SETTLE);
    }

    function settle() {
      // A finger is still down: writing scrollLeft now would be visible or ignored. The
      // touchend/pointerup handlers re-arm this.
      if (gesturing) return;

      normalize();

      // Then re-read where we actually are and keep the dots honest. Nearest card to the left
      // edge, to match scroll-snap-align:start.
      var x = track.scrollLeft, best = head, bd = Infinity;
      for (var i = 0; i < all.length; i++) {
        var d = Math.abs(offsetOf(all[i]) - x);
        if (d < bd) { bd = d; best = i; }
      }
      var real = looping
        ? ((((best - head) % k) + k) % k)
        : Math.min(Math.max(best, 0), k - 1);
      mark(real);
    }

    // Native horizontal scroll and swipe stay in charge; this only re-reads where they landed.
    track.addEventListener('scroll', schedule, { passive: true });

    function gstart() { gesturing = true; clearTimeout(tick); }
    function gend() { if (gesturing) { gesturing = false; schedule(); } }

    track.addEventListener('touchstart', gstart, { passive: true });
    track.addEventListener('pointerdown', gstart, { passive: true });
    // On window too: a finger or pointer released off the track still ends the gesture.
    window.addEventListener('touchend', gend, { passive: true });
    window.addEventListener('touchcancel', gend, { passive: true });
    window.addEventListener('pointerup', gend, { passive: true });
    window.addEventListener('pointercancel', gend, { passive: true });

    /* ---------- controls ---------- */
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { go(n, true); });
    });

    track.addEventListener('keydown', function (e) {
      var key = e.key;
      if (key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (key === 'Home') { e.preventDefault(); go(0, true); }
      else if (key === 'End') { e.preventDefault(); go(k - 1, true); }
    });

    /* ---------- build, and rebuild when the breakpoint changes ----------
       Card widths are flex-basis percentages, so m and loopW are per-breakpoint. Only width
       matters: ignoring height-only resizes keeps a phone's URL bar hiding from rebuilding the
       strip under the user's thumb. */
    var lastW = track.clientWidth;
    var rz = null;

    buildClones();
    mark(0);

    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () {
        if (track.clientWidth === lastW) return;
        lastW = track.clientWidth;
        var keep = current;
        buildClones();
        go(keep, false);
      }, 180);
    });

    /* ---------- autoplay — off unless the section asks for it, and never under reduced motion ---------- */
    var ms = parseInt(root.getAttribute('data-autoplay-ms'), 10);
    var wants = root.getAttribute('data-autoplay') === '1' && ms >= 1000;
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    if (wants && !reduce) {
      var timer = null;
      var play = function () { if (!timer) timer = setInterval(function () { step(1); }, ms); };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);
      root.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else play();
      });
      play();
    }
  });
})();

/* ---------------- trust badge -> FAQ answer ----------------
   The badges under the add-to-cart button link to #tpdp-faq-<slug>. A plain hash jump would land on
   a <details> that is still closed, so open it first, then scroll. Its own IIFE and no dependency on
   [data-tpdp-main], because the FAQ section renders on pages that have no buy box.

   No IntersectionObserver and no requestAnimationFrame: neither fires in the preview webview. */
(function () {
  'use strict';

  function reveal(hash) {
    if (!hash || hash.indexOf('#tpdp-faq-') !== 0) return false;
    var el;
    try { el = document.querySelector(hash); } catch (e) { return false; }
    if (!el) return false;
    var d = el.tagName === 'DETAILS' ? el : (el.closest ? el.closest('details') : null);
    if (d) {
      d.open = true;
      d.classList.add('tpdp-hit');
      setTimeout(function () { d.classList.remove('tpdp-hit'); }, 1600);
    }
    try { el.scrollIntoView({ block: 'center' }); } catch (e) { el.scrollIntoView(); }
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href^="#tpdp-faq-"]');
    if (!a) return;
    var hash = a.getAttribute('href');
    if (reveal(hash)) {
      e.preventDefault();
      // Keep the address bar honest without triggering a second native jump.
      if (window.history && history.replaceState) history.replaceState(null, '', hash);
    }
  });

  // Someone arriving on a shared #tpdp-faq-â€¦ link should land on an open answer too.
  if (window.location.hash) reveal(window.location.hash);
})();

/* ---------------- cross-sell: the companion piece ----------------
   Renders the other half of a pair (ring <-> bracelet) with the finish inherited from the buy
   box. Pairing is BY POSITION: parentColours[i] corresponds to colours[i], because the two
   products name the same finish differently (Sidabrinis / Sidabrinė, Juodas / Juoda).
   Adds in place with fetch so the shopper keeps their scroll position. */
(function () {
  var root = document.querySelector('[data-tpdp-cs]');
  if (!root) return;
  var raw = root.querySelector('[data-tpdp-cs-data]');
  if (!raw) return;
  var D;
  try { D = JSON.parse(raw.textContent); } catch (e) { return; }

  var elPrice   = root.querySelector('[data-tpdp-cs-price]');
  var elInherit = root.querySelector('[data-tpdp-cs-inherit]');
  var elColour  = root.querySelector('[data-tpdp-cs-colour]');
  var elImg     = root.querySelector('[data-tpdp-cs-img]');
  var elCta     = root.querySelector('[data-tpdp-cs-cta]');
  var btnAdd    = root.querySelector('[data-tpdp-cs-add]');
  var elErr     = root.querySelector('[data-tpdp-cs-err]');
  var chips     = [].slice.call(root.querySelectorAll('[data-tpdp-cs-size]'));

  var colour = D.colours.length ? D.colours[0] : null;
  var size   = D.sizes.length ? D.sizes[0] : null;
  /* What the buy box last told us. The "same colour as the ring" line is only honest while the
     shopper has not overridden it, so we keep the inherited value separately from the chosen one. */
  var inherited = null;
  var swBtns = [].slice.call(root.querySelectorAll('[data-tpdp-cs-sw-btn]'));
  var elPrefix = root.querySelector('[data-tpdp-cs-prefix]');

  function money(cents) {
    var v = cents / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
    return '€' + s;
  }
  function find(c, s) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if ((c === null || v.colour === c) && (s === null || v.size === s)) return v;
    }
    return null;
  }
  function anyInColour(s) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (v.size === s && (colour === null || v.colour === colour) && v.available) return true;
    }
    return false;
  }

  function paint() {
    var v = find(colour, size);
    if (elPrice) elPrice.textContent = v ? money(v.price) : '';
    if (elColour && colour) elColour.textContent = colour;
    if (elInherit) elInherit.hidden = !colour;
    /* srcset wins over src, so assigning src alone changed nothing on screen — the picture stayed
       silver while the price and label moved to rose gold. Drop srcset/sizes before swapping. */
    if (v && v.img && elImg && elImg.getAttribute('src') !== v.img) {
      elImg.removeAttribute('srcset');
      elImg.removeAttribute('sizes');
      elImg.setAttribute('src', v.img);
    }

    chips.forEach(function (b) {
      var sv = b.getAttribute('data-value');
      b.setAttribute('aria-pressed', sv === size ? 'true' : 'false');
      var ok = anyInColour(sv);
      if (ok) b.removeAttribute('disabled'); else b.setAttribute('disabled', '');
    });

    swBtns.forEach(function (b) {
      var cv = b.getAttribute('data-value');
      b.setAttribute('aria-pressed', cv === colour ? 'true' : 'false');
      var any = false;
      for (var i = 0; i < D.variants.length; i++) {
        if (D.variants[i].colour === cv && D.variants[i].available) { any = true; break; }
      }
      b.setAttribute('data-soldout', any ? '0' : '1');
    });

    /* Only claim "same as the ring" while it is actually true. */
    if (elPrefix) elPrefix.hidden = !(inherited && colour === inherited);

    if (btnAdd) {
      if (v && v.available) {
        btnAdd.removeAttribute('disabled');
        if (elCta) elCta.textContent = D.t.cta;
      } else {
        btnAdd.setAttribute('disabled', '');
        if (elCta) elCta.textContent = D.t.soldout;
      }
    }
    if (elErr) elErr.hidden = true;
  }

  chips.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('disabled')) return;
      size = b.getAttribute('data-value');
      paint();
    });
  });

  swBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var cv = b.getAttribute('data-value');
      if (cv === colour) return;
      colour = cv;
      /* Picking a colour that this size does not come in should move the size, not dead-end. */
      if (!anyInColour(size)) {
        for (var i = 0; i < D.sizes.length; i++) { if (anyInColour(D.sizes[i])) { size = D.sizes[i]; break; } }
      }
      root.removeAttribute('data-added');
      paint();
    });
  });

  /* Inherit the finish from the buy box. The event carries the parent's chosen values but not
     which option is the colour, so the section tag passes the parent's colour-option index. */
  var pIdx = parseInt(root.getAttribute('data-colour-index'), 10);
  document.addEventListener('tpdp:variant', function (e) {
    if (pIdx !== 0 && pIdx !== 1) return;
    var picked = pIdx === 0 ? e.detail.o1 : e.detail.o2;
    /* Prefer the explicit map. Position is only a fallback for a pair whose two products happen
       to list their colours in the same order — the Latvian ring and bracelet do NOT, so a
       positional match there would silently offer (and add) the wrong finish. */
    var mapped = D.pairs && D.pairs[picked];
    if (mapped && D.colours.indexOf(mapped) > -1) {
      inherited = mapped;
      colour = inherited;
      root.removeAttribute('data-added');
      if (!anyInColour(size)) {
        for (var k = 0; k < D.sizes.length; k++) { if (anyInColour(D.sizes[k])) { size = D.sizes[k]; break; } }
      }
      paint();
      return;
    }
    var at = D.parentColours.indexOf(picked);
    if (at > -1 && D.colours[at]) {
      /* The buy box always wins: changing the ring's finish re-syncs this block, overriding any
         manual pick. That is the behaviour the brief asked for — the pair matching by default. */
      inherited = D.colours[at];
      colour = inherited;
      root.removeAttribute('data-added');
      if (!anyInColour(size)) {
        for (var i = 0; i < D.sizes.length; i++) { if (anyInColour(D.sizes[i])) { size = D.sizes[i]; break; } }
      }
      paint();
    }
  });

  if (btnAdd) {
    btnAdd.addEventListener('click', function () {
      var v = find(colour, size);
      if (!v || !v.available) return;
      btnAdd.setAttribute('disabled', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        if (elCta) elCta.textContent = D.t.added;
        root.setAttribute('data-added', '1');
        /* Nudge whatever cart UI is mounted; harmless if nobody listens. */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:build'));
      }).catch(function () {
        btnAdd.removeAttribute('disabled');
        if (elErr) { elErr.textContent = D.t.err; elErr.hidden = false; }
      });
    });
  }

  paint();
})();
